import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';
import { EgiPageNavigationService } from '@/app/platform/platform-context/egi-page-navigation.service';
import { HdChartManagerComponent } from '@/app/human-design/chart/library/hd-chart-manager.component';
import { HdContentLanguageService } from '@/app/human-design/chart/bodygraph/hd-content-language.service';
import { HD_CHART_ENVIRONMENT_PAGE_ID } from '../hd-page-ids';

@Component({
  selector: 'chart-manager-page',
  standalone: true,
  imports: [SharedModule, HdChartManagerComponent],
  templateUrl: './chart-manager-page.component.html',
  styleUrl: './chart-manager-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartManagerPageComponent {
  private readonly egiPageNavigation = inject(EgiPageNavigationService);
  private readonly transloco = inject(TranslocoService);
  private readonly contentLang = inject(HdContentLanguageService);

  protected readonly title = computed(() => {
    this.contentLang.translationsLoadedTick();
    return this.transloco.translate<string>(
      'humanDesign.chartManager.title',
      undefined,
      this.contentLang.effectiveLang(),
    );
  });

  /**
   * Inladen vanaf de pagina → de chart-omgeving met ?loadChartId=. Via de
   * page-navigatieservice: de route leeft onder het appId-segment en de guard
   * vereist een navId (menu-rechten).
   */
  onLoadChart(payload: { id: string }): void {
    this.egiPageNavigation.navigateToPage(HD_CHART_ENVIRONMENT_PAGE_ID, { loadChartId: payload.id });
  }

  /**
   * Rij-actie "Tijdlijn": eerst de chart in de chart-omgeving openen, die dan
   * doorklikt naar de levenstijdlijn — zo komt de breadcrumb-terugknop op de
   * chart zelf uit (wens Steven, stap 5-naronde).
   */
  onTimeline(chartId: string): void {
    this.egiPageNavigation.navigateToPage(HD_CHART_ENVIRONMENT_PAGE_ID, { loadChartId: chartId, openTimeline: '1' });
  }
}
